"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var ListingBookmarkButton = /** @class */ (function (_super) {
    __extends(ListingBookmarkButton, _super);
    function ListingBookmarkButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function (e) {
            e.stopPropagation();
            var bookmark = _this.props.bookmarkList.getBookmarkForListingId(_this.props.listingId);
            if (bookmark) {
                _this.props.bookmarkList.removeBookmark(bookmark);
            }
            else {
                _this.props.bookmarkList.addBookmark({ listing: { id: _this.props.listingId } });
            }
        };
        _this._onRenderSyncIcon = function () {
            return React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small });
        };
        return _this;
    }
    ListingBookmarkButton.prototype.componentWillMount = function () {
        this.props.bookmarkList.load();
    };
    ListingBookmarkButton.prototype.render = function () {
        var _a = this.props, listingId = _a.listingId, bookmarkList = _a.bookmarkList;
        var sync = bookmarkList.sync;
        var syncing = sync.syncing && (sync.type !== "update" || sync.id === String(listingId));
        var bookmark;
        if (!syncing) {
            bookmark = this.props.bookmarkList.getBookmarkForListingId(listingId);
        }
        var title = syncing ? "Please wait..." : bookmark ? "Bookmarked - Click to Remove" : "Click to Set Bookmark";
        var props = {
            onClick: this._onClick,
            title: title,
            primary: true,
            checked: bookmark ? true : false,
            iconProps: { iconName: bookmark ? "SingleBookmarkSolid" : "SingleBookmark" },
            disabled: syncing,
            ariaDescription: title,
            onRenderIcon: syncing ? this._onRenderSyncIcon : undefined
        };
        return React.createElement(Button_1.IconButton, __assign({}, props));
    };
    ListingBookmarkButton = __decorate([
        mobx_react_1.observer
    ], ListingBookmarkButton);
    return ListingBookmarkButton;
}(React.Component));
exports.ListingBookmarkButton = ListingBookmarkButton;
